<template>
    <div>
        <div class="mt-5">
            <h2 class="text-center text-muted">
                ¡ Muchas gracias por tu solicitud ¡
            </h2>
            <h5 class="text-center">
                Un ejecutivo de ventas se comunicara contigo en breve.
            </h5>
        </div>
        <div class="form-group mt-5">
            <button
                class="btn btn-block text-uppercase"
                 type="submit"
                @click="redirectView"
            >
                Regresar a la ficha técnica
                <span class="angle_arrow"
                    ><i class="fa fa-angle-right" aria-hidden="true"></i
                ></span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        redirectView() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var ficha_tecnica = urlParams.get("ficha_tecnica");
            window.location.href = "/ficha_tecnica/" + ficha_tecnica + "?type=offers";
        }
    }
};
</script>

<style lang="scss">

</style>
